var React = require('react');

function CalendarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-calendar","data-name":"Icon awesome-calendar","d":"M.422,6.748h14.9a.423.423,0,0,1,.422.422v9.137a1.687,1.687,0,0,1-1.687,1.687H1.687A1.687,1.687,0,0,1,0,16.307V7.169A.423.423,0,0,1,.422,6.748ZM15.745,5.2V3.936a1.687,1.687,0,0,0-1.687-1.687H12.371V.422A.423.423,0,0,0,11.949,0H10.543a.423.423,0,0,0-.422.422V2.249h-4.5V.422A.423.423,0,0,0,5.2,0H3.8a.423.423,0,0,0-.422.422V2.249H1.687A1.687,1.687,0,0,0,0,3.936V5.2a.423.423,0,0,0,.422.422h14.9A.423.423,0,0,0,15.745,5.2Z","fill":"#fff"}));
}

CalendarInline.defaultProps = {"width":"15.745","height":"17.994","viewBox":"0 0 15.745 17.994"};

module.exports = CalendarInline;

CalendarInline.default = CalendarInline;
